import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import { ENGAGEMENT_STATUS, ENGAGEMENT_LOOKUP_CATEGORIES } from "@/lib/constants/engagement-codes"
import { useEngagementLookups } from "@/hooks/use-engagement-lookups"

interface EngagementStatusBadgeProps {
  status: string
  className?: string
}

// Get status colors and styles
const getStatusClassName = (status: string) => {
  switch (status) {
    case ENGAGEMENT_STATUS.DRAFT:
    case ENGAGEMENT_STATUS.ACCOUNTING_DRAFT:
      return "bg-orange-100 text-orange-800 hover:bg-orange-100"
    case ENGAGEMENT_STATUS.PENDING_REVIEW:
      return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100"
    case ENGAGEMENT_STATUS.ACTIVE:
    case ENGAGEMENT_STATUS.PENDING_CHANGE:
      return "bg-green-100 text-green-800 hover:bg-green-100"
    case ENGAGEMENT_STATUS.COMPLETED:
      return "bg-blue-100 text-blue-800 hover:bg-blue-100"
    case ENGAGEMENT_STATUS.REPLACED:
      return "bg-gray-100 text-gray-800 hover:bg-gray-100"
    default:
      return "bg-gray-300 text-gray-800 hover:bg-gray-100"
  }
}

// GW-330: one pill rendering everywhere (list, version dropdown, toolbar). The old "dot" variant
// (coloured dot + "Status" label) existed only so the toolbar and the setup summary card could show
// the status differently in different states, which is the inconsistency GW-330 removes.
export function EngagementStatusBadge({ status, className }: EngagementStatusBadgeProps) {
  const { getValue } = useEngagementLookups()

  // Get display text from lookups, fallback to raw status if not found
  const statusDisplayText = getValue(ENGAGEMENT_LOOKUP_CATEGORIES.STATUS, status)?.value || status

  return (
    <Badge className={cn("font-medium whitespace-nowrap", getStatusClassName(status), className)}>
      {statusDisplayText}
    </Badge>
  )
}
